const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'heic', 'gif', 'webp']

/**
 * Определяет, является ли файл изображением, по расширению в имени
 * (новая точка файлов не отдаёт отдельное поле `ext`, только `name`).
 */
export const isImageFileName = (name: string): boolean => {
  const ext = name.split('.').pop()?.toLowerCase() ?? ''
  return IMAGE_EXTENSIONS.includes(ext)
}
